<template>
  <!-- 菜单管理 -->
  <div class="page">
    <div class="paginations" :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <!-- 防止输入框回车刷新页面 -->
          <el-form-item label="" v-show="false">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="菜单名称：">
            <el-input
              size="small"
              v-model="searchData.title"
              placeholder="请输入菜单名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search('')"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
            </div>
          </el-form-item>
        </el-form>
        <div class="addition">
          <el-button @click="add()">
            添加
            <i class="h_icon icon-add"></i>
          </el-button>
        </div>
      </div>
      <div class="table_box">
        <el-table
          :data="tableObj.list"
          row-key="id"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          style="width: 100%"
        >
          <el-table-column prop="title" label="菜单名称" class-name="first">
            <template slot-scope="scope">
              <p style="padding-left: 23px" v-if="scope.row.level === 1 && !scope.row.children">
                {{ scope.row.title }}
              </p>
              <span v-else>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="路由名称"></el-table-column>
          <el-table-column prop="level" label="菜单级数">
            <template slot-scope="scope">
              <span>{{ scope.row.level }}级菜单</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <i class="icona icon-add" title="添加" @click="add(scope.row)"></i>
              <i class="icona icon-edit" title="编辑" @click="edit(scope.row)"></i>
              <i class="icona icon-delete" title="删除" @click="cutOut(scope.row.id)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 添加弹窗 -->
    <el-dialog
      :title="uploadBox.title"
      :visible.sync="uploadBox.show"
      :close-on-click-modal="false"
      width="600px"
      class="pop_up"
      append-to-body
      :before-close="handleClose"
      @opened="opened"
    >
      <el-form ref="uploadBox" :model="uploadBox.data" :rules="uploadBox.rules" label-width="100px">
        <el-form-item label="菜单名称：" prop="title" required>
          <el-input v-model="uploadBox.data.title" placeholder="请输入。。。"></el-input>
        </el-form-item>
        <el-form-item label="路由名称：" prop="name" required>
          <el-input v-model="uploadBox.data.name" placeholder="请输入。。。"></el-input>
        </el-form-item>

        <el-form-item label="父级菜单：" prop="parentId" v-if="showParentInput">
          <el-input v-model="uploadBox.data.parentName" disabled></el-input>
          <el-input v-model="uploadBox.data.parentId" style="display: none"></el-input>
        </el-form-item>

        <el-form-item label="菜单顺序：" prop="sort">
          <el-input-number
            v-model="uploadBox.data.sort"
            :min="0"
            label="请输入。。。"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="选中图标：" prop="suIcon">
          <el-input v-model="uploadBox.data.suIcon" placeholder="请输入。。。"></el-input>
        </el-form-item>
        <el-form-item label="未选中图标：" prop="uicon">
          <el-input v-model="uploadBox.data.uicon" placeholder="请输入。。。"></el-input>
        </el-form-item>
      </el-form>
      <div class="tx-center">
        <el-button size="small" @click="submitUpload">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageNumber from "@/components/pageNumber.vue"; //分页

export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      searchData: {
        title: "",
        pageDto: {
          pageNum: 1, //当前显示的页面页码数
          pageSize: 10,
        },
      },
      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },
      showParentInput:false,
      // 添加弹窗
      uploadBox: {
        show: false,
        title: "添加用户",
        data: {
          id: null,
          parentId: null,
          parentName: "",
          title: "",
          name: "",
          level: "",
          sort: "",
          suIcon: "",
          uicon: "",
        },
        rules: {
          title: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
          name: [{ required: true, message: "请输入路由名称", trigger: "blur" }],
        },
      },
    };
  },
  created() {
    this.search();
    this.$store.commit("modifyVague", false);
  },
  methods: {
    // 查询表格
    search(search) {
      this.searchData.pageDto.pageNum = search ? search : 1;
      this.tableObj.jumpTo = search ? search : 1;
      this.$axios
        .post(this.$apiurls.account_getMenuList, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.tableObj.list = res.data.list;
            this.tableObj.total = res.data.total;
          }
        });
    },
    // 重置表格
    reset() {
      this.searchData.title = "";
      this.search();
    },

    // 添加
    add(row) {
      this.uploadBox.show = true;
      this.uploadBox.title = "添加菜单";
      this.$store.commit("modifyVague", true);

      if(row){
        this.uploadBox.data.parentId = row.id;
        this.uploadBox.data.parentName = row.title;
        this.uploadBox.data.level = row.level + 1;
        this.showParentInput=true
      }else {
        this.uploadBox.data.parentId =0;
        this.uploadBox.data.parentName = "";
        this.uploadBox.data.level = 1;
        this.showParentInput=false
      }

      this.uploadBox.data.id = null;
      this.uploadBox.data.title = "";
      this.uploadBox.data.name = "";
      this.uploadBox.data.sort = 0;
      this.uploadBox.data.suIcon = "";
      this.uploadBox.data.uicon = "";
    },

    // 编辑
    edit(row) {
      this.uploadBox.show = true;
      this.uploadBox.title = "编辑菜单";
      this.$store.commit("modifyVague", true);
      if(row.level==1) this.showParentInput=false
      else  this.showParentInput=true

      this.uploadBox.data.id = row.id;
      this.uploadBox.data.parentId = row.parentId;
      this.uploadBox.data.parentName = row.parentName;
      this.uploadBox.data.level = row.level;
      this.uploadBox.data.title = row.title;
      this.uploadBox.data.name = row.name;
      this.uploadBox.data.sort = row.sort;
      this.uploadBox.data.suIcon = row.suIcon;
      this.uploadBox.data.uicon = row.uicon;
    },

    // 删除
    cutOut(id) {
      this.$store.commit("modifyVague", true);
      this.$confirm("此操作将永久删除该菜单, 是否继续?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.$axios
            .post(this.$apiurls.account_deleteMenuInfo, id, {
              loading: false,
            })
            .then((res) => {
              if (res) {
                if (res.data) {
                  this.search("");
                  this.$message({
                    message: "删除成功！",
                    type: "success",
                  });
                } else {
                  this.$message.error("删除失败！");
                }
              }
              this.$store.commit("modifyVague", false);
            });
        })
        .catch(() => {
          this.$store.commit("modifyVague", false);
        });
    },

    // 打开弹窗
    opened() {
      this.$refs.uploadBox.clearValidate();
    },

    // 关闭弹窗
    handleClose() {
      this.uploadBox.show = false;
      this.$store.commit("modifyVague", false);
    },

    // 添加/修改
    submitUpload() {
      this.$refs.uploadBox.validate((valid) => {
        if (valid) {
          this.$axios
            .post(this.$apiurls.account_saveOrUpdateMenuInfo, this.uploadBox.data, {
              loading: false,
            })
            .then((res) => {
              if (res) {
                if (res.data) {
                  this.$message({
                    message: this.uploadBox.data.id ? "编辑成功！" : "添加成功！",
                    type: "success",
                  });
                }
                this.uploadBox.show = false;
                this.$store.commit("modifyVague", false);
                this.search();
              }
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.addition{
  margin-top: 5px;
}
// 搜索
.table-search-box-hander {
  display: flex;
  justify-content: space-between;
}
.el-form {
  height: 100%;
}
.table_box ::v-deep .el-table .first .cell {
  justify-content: flex-start;
  padding-left: 20%;
}
</style>
